import { useEffect, useState } from 'react'
import moment from 'moment-jalaali'
import getCutoff from 'client-sdk/src/orders/getCutoff'
import getValidDays from 'client-sdk/src/parcels/getValidDays'
import handleError from '../../../utils/handleError'

export const useCutoffHandler = ({
  courierId,
  dateSelected,
  editMode,
  entityName,
  fulfillmentTypeId,
  setDateInDatePiker,
  setValue
}: {
  courierId: any
  dateSelected: string
  entityName: string
  editMode?: boolean
  fulfillmentTypeId: any
  setValue: (name: string, value: any) => void
  setDateInDatePiker: (date: string) => void
}) => {
  const [listCutoff, setListCutoff] = useState<any[]>([])
  const [listOneCutoff, setListOneCutoff] = useState<any[]>([])
  const [isWeekend, setIsWeekend] = useState(false)

  const now = new Date()
  const date = new Date()

  moment.locale('en')
  const monthNumber = parseInt(moment(dateSelected).format('jDD'))
  const weekNumber =
    ((moment(dateSelected, 'YYYY-MM-DD').weekday() + 1) % 7) + 1

  const checkCutoff = (cvdd: string, getListCutoff: any[]) => {
    const updatedList = getListCutoff.map((item) => {
      const formattedTime = item.startTime
      const dateNow = `${dateSelected} ${formattedTime}`

      const date1 = moment(dateNow)
      const date2 = moment(cvdd)

      const startHour = parseInt(item.startTime.split(':')[0])
      const endHour = parseInt(item.endTime.split(':')[0])

      return {
        ...item,
        disableCutoff: !date1.isSameOrAfter(date2),
        value: `${item.startTime.split(':')[0]}-${item.endTime.split(':')[0]}`,
        label: `${startHour === 0 ? 24 : startHour} الی ${
          endHour === 0 ? 24 : endHour
        }`
      }
    })
    setListCutoff(updatedList)
  }

  const handlerDistance = (distance: string) => {
    switch (distance) {
      case 'HOURS':
        return 'hours'
      case 'MINUTES':
        return 'minutes'
      case 'DAYS':
        return 'days'
      default:
        throw new Error('Unsupported unit')
    }
  }

  let isValidDateFound = false
  let isDayOfMonth = false
  let isdayOfWeek = false

  const handlerHolidays = (date: any) => {
    const dayOfMonth = moment(date).jDate()
    const dayOfWeek = ((moment(new Date(date)).weekday() + 1) % 7) + 1

    if (!(listOneCutoff.length > 0)) {
      return date.getDay() === 5
    }

    return isWeekend
      ? !listOneCutoff.includes(dayOfWeek)
      : !listOneCutoff.some((day: any) => day === dayOfMonth) ||
          date.getDay() === 5
  }

  useEffect(() => {
    const handlerGetValidDays = async () => {
      try {
        const { res, ok } = await getValidDays(fulfillmentTypeId, courierId)
        const { type, validDays } = res

        switch (type) {
          case 'DAY_OF_WEEK':
            setIsWeekend(true)
            isdayOfWeek = true
            setListOneCutoff(validDays)
            break
          case 'DAY_OF_MONTH':
            isDayOfMonth = true
            setIsWeekend(false)
            setListOneCutoff(validDays)
            break
          case 'ALL':
            setListOneCutoff([])
            isValidDateFound = true
            break
        }
      } catch (error) {}
    }

    const handlerGetCutoff = async () => {
      if (courierId && dateSelected) {
        try {
          const { res, ok } = await getCutoff(
            dateSelected,
            courierId,
            fulfillmentTypeId,
            false,
            entityName
          )

          if (ok) {
            while (isValidDateFound) {
              for (const item of res) {
                if (item.dayOfWeek === null && item.dayOfMonth === null) {
                  const formattedDateNow = moment(now).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  let formattedDate = moment(date).format('YYYY-MM-DD')

                  const formattedTime = item.startTime
                  const cvdd = `${formattedDate} ${formattedTime}`

                  const momentDate1 = moment(cvdd, 'YYYY-MM-DD HH:mm:ss')
                  const momentDate2 = moment(
                    formattedDateNow,
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  const difference = momentDate1.diff(
                    momentDate2,
                    handlerDistance(item.acceptableDistanceUnit)
                  )

                  if (difference >= item.acceptableDistance) {
                    checkCutoff(cvdd, res)
                    setDateInDatePiker(formattedDate)
                    const smallDate = new Date(formattedDate)
                    const dateSelect = new Date(dateSelected)
                    if (dateSelect < smallDate) {
                      if (!editMode) {
                        setValue('deliveryDate', formattedDate)
                      }
                    }
                    isValidDateFound = false
                    break
                  }
                }
              }
              date.setDate(date.getDate() + 1)
            }

            while (isdayOfWeek) {
              for (const item of res) {
                if (item.dayOfWeek !== null && item.dayOfMonth === null) {
                  const formattedDateNow = moment(now).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  let formattedDate = moment(date).format('YYYY-MM-DD')

                  const formattedTime = item.startTime
                  const cvdd = `${formattedDate} ${formattedTime}`

                  const momentDate1 = moment(cvdd, 'YYYY-MM-DD HH:mm:ss')
                  const momentDate2 = moment(
                    formattedDateNow,
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  const difference = momentDate1.diff(
                    momentDate2,
                    handlerDistance(item.acceptableDistanceUnit)
                  )

                  if (difference >= item.acceptableDistance) {
                    if (item.dayOfWeek === weekNumber) checkCutoff(cvdd, [item])
                    setDateInDatePiker(formattedDate)
                    const smallDate = new Date(formattedDate)
                    const dateSelect = new Date(dateSelected)
                    if (dateSelect < smallDate) {
                      if (!editMode) {
                        setValue('deliveryDate', formattedDate)
                      }
                    }
                    isdayOfWeek = false
                  }
                }
              }
              date.setDate(date.getDate() + 1)
            }

            while (isDayOfMonth) {
              for (const item of res) {
                if (item.dayOfWeek === null && item.dayOfMonth !== null) {
                  const formattedDateNow = moment(now).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  let formattedDate = moment(date).format('YYYY-MM-DD')

                  const formattedTime = item.startTime
                  const cvdd = `${formattedDate} ${formattedTime}`

                  const momentDate1 = moment(cvdd, 'YYYY-MM-DD HH:mm:ss')
                  const momentDate2 = moment(
                    formattedDateNow,
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  const difference = momentDate1.diff(
                    momentDate2,
                    handlerDistance(item.acceptableDistanceUnit)
                  )

                  if (difference >= item.acceptableDistance) {
                    if (item.dayOfMonth === monthNumber)
                      checkCutoff(cvdd, [item])
                    setDateInDatePiker(formattedDate)
                    const smallDate = new Date(formattedDate)
                    const dateSelect = new Date(dateSelected)
                    if (dateSelect < smallDate) {
                      if (!editMode) {
                        setValue('deliveryDate', formattedDate)
                      }
                    }
                    isDayOfMonth = false
                  }
                }
              }
              date.setDate(date.getDate() + 1)
            }
          }
        } catch (error) {
          handleError(error)
        }
      }
    }
    handlerGetValidDays()
    handlerGetCutoff()
  }, [courierId, dateSelected, fulfillmentTypeId])

  return { listCutoff, handlerHolidays }
}
